import consumer from "./consumer";

const EssayPromptsChannel = function () {
  consumer.subscriptions.create("EssayPromptsChannel", {
    connected() {
      // console.log('connected');
    },

    disconnected() {
      // console.log('disconnected')
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      $("#response-area").html(data.body);
    }
  });
};

export default EssayPromptsChannel;
